module.exports = __webpack_public_path__ + "images/marketing/eighthlight-logo.png";